import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  isLogedin:boolean;
  constructor(private auth:AuthService) { }

  ngOnInit() {
    this.auth.currentLoginStatus.subscribe(status => this.isLogedin = status);
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/footer/footer.component.ts